import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import KeysTable from './KeysTable';
import { wrapTemplateKey, type TemplateKeyRow } from '../keysUtils';
import { GENERAL_TEMPLATE_KEYS } from '../../model/buildObjectTemplateValueKeys';
import { getCurrencyI18nParams } from 'utils/helpers/currency/currencyHelpers';

interface GeneralKeysTabProps {
    onKeySelect?: (key: string) => void;
    showWarrantyProducts?: boolean;
}

const GeneralKeysTab = ({ onKeySelect, showWarrantyProducts = false }: GeneralKeysTabProps) => {
    const { t } = useTranslation('TemplateValueKeys');
    const currencyParams = getCurrencyI18nParams();

    const rows = useMemo<TemplateKeyRow[]>(() => {
        const items = GENERAL_TEMPLATE_KEYS.map((name) => ({
            key: wrapTemplateKey(name),
            value: t(`directory.general.${name}`, currencyParams),
        }));
        if (!showWarrantyProducts) return items;
        return [
            ...items,
            {
                key: wrapTemplateKey('warrantyProducts'),
                value: t('directory.general.warrantyProducts'),
            },
        ];
    }, [showWarrantyProducts, t, currencyParams.baseCode, currencyParams.localName]);

    return <KeysTable rows={rows} onKeySelect={onKeySelect} />;
};

export default GeneralKeysTab;
